import React, { PureComponent } from 'react';
import TableHeader from './TableHeader.jsx';
import TableBody from './TableBody.jsx';

class Table extends PureComponent {
    constructor(props) {
        super(props);

    }

    render() {
        const { 
            column, 
            orderColumn, 
            columnIndex, 
            procesos, 
            checkActivo, 
            routeToEditarConfiguracionProceso, 
            administratorSelected,
            columnaActivaOrdenamiento,
            desactivarProceso 
        } = this.props;

        const sinResultados = procesos.filter(x => x.AdministradoraId == (administratorSelected || null)).length == 0;

        return (

            <div>

              
                <table className="table clickeable-row-table">
                    <TableHeader
                        column={column}
                        orderColumn={orderColumn}
                        columnIndex={columnIndex}
                        columnaActivaOrdenamiento={columnaActivaOrdenamiento}
                    />
                    <TableBody
                        procesos={procesos}
                        checkActivo={checkActivo}
                        administratorSelected={administratorSelected}
                        routeToEditarConfiguracionProceso={routeToEditarConfiguracionProceso}
                        desactivarProceso={desactivarProceso} 
                    />
                </table>

                <div>
                    {sinResultados ?
                        <div className="ConfiguracionProcesos__Tabla--SinResultados">No se encontraron resultados</div>
                    :
                        null
                    }
                </div>

            </div>
        )
    }
};

export default Table;